import React from "react";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import ReactSelect from "react-select";
import { customSelect } from "../../misc/customStyle-ReactSelect";
import { stateOptions, citiesOptions } from "../../misc/customOptions";
import { list_states, list_countries } from "../../services/getLocations";
import { RequiredOptionsTypes, SelectTypes, SelectValueTypes } from "./types";

export function Select({
	value,
	control,
	inputRef,
	required,
	onBlur,
	onChange,
	placeholder,
	options,
	name,
	watchField,
}: SelectTypes) {
	const ufValue = useWatch({
		control,
		name: watchField ? watchField : "",
		disabled: !watchField,
	});

	const [requiredOptions, setRequiredOptions] =
		useState<RequiredOptionsTypes[]>(options);
	const [selectValue, setSelectValue] = useState<SelectValueTypes>();

	useEffect(() => {
		async function loadRequiredOptions() {
			let newRequiredOptions: { label: string; value: string }[] = [];
			switch (required) {
				case "states":
					newRequiredOptions = await getStatesOptions();
					break;
				case "cities":
					if (ufValue) {
						if (watchField === "cmbUFnaturalidade") {
							newRequiredOptions =
								citiesOptions[
									stateOptions.filter(
										(state) => state.value === ufValue,
									)[0].label
								];
						} else {
							newRequiredOptions = citiesOptions[ufValue];
						}
						if (selectValue && newRequiredOptions.length) {
							setSelectValue(newRequiredOptions[0]);
						}
					}
					break;
				case "countries":
					newRequiredOptions = await getCountriesOptions();
					break;

				default:
					return;
			}
			setRequiredOptions(newRequiredOptions);
		}
		loadRequiredOptions();
	}, [required, ufValue]);

	// useEffect(() => {
	// 	if (name === "cmbMunicipioAgenciaRelacionamento"){
	// 		console.log('value', value)
	// 		console.log('requiredOptions', requiredOptions)
	// 		console.log('VALOR DA MONTAGEM', requiredOptions?.filter((rOption) => rOption.value === value)[0])
	// 	}

	// }, [])

	useEffect(() => {
		setSelectValue(
			requiredOptions?.filter((rOption) => rOption.value === value)[0] ||
				value,
		);
	}, [value, requiredOptions]);


	/*
	useEffect(() => {
		if(name == "cmbTpOcupacao") {
			console.log('valor select: ' + JSON.stringify(selectValue?.value))
		}

		if(name == "cmbGrauInstrucao") {
			console.log('valor select2: ' + JSON.stringify(selectValue?.value))
		}
	}, [selectValue])
	*/

	return (
		<ReactSelect
			placeholder={placeholder}
			options={requiredOptions}
			noOptionsMessage={() =>
				required === "cities"
					? "Selecione o Estado"
					: "Não existe opções para esta categoria"
			}
			onChange={(val) => {
				onChange(val?.value);
			}}
			onBlur={onBlur}
			value={selectValue}
			defautValue={
				requiredOptions?.filter((rOption) => rOption.value === value)[0]
			}
			className='input select-input'
			name={name}
			ref={inputRef}
			styles={customSelect}
		/>
	);
}

async function getCountriesOptions() {
	try {
		const data = await list_countries();
		const options = data.map((item: any) => {
			return {
				label: item.nome.abreviado,
				value: item.nome.abreviado,
			};
		});
		return options;
	} catch (error) {
		return error;
	}
}

async function getStatesOptions() {
	try {
		const data = await list_states();
		const options = data.map((item: any) => {
			return { label: item.nome, value: item.id };
		});
		return options;
	} catch (error) {
		return error;
	}
}

async function getCitiesOptions(UF: number) {
	try {
		let stateSlecte = { label: "", value: "" };
		stateOptions.forEach((state) => {
			if (state.value === String(UF)) {
				stateSlecte = state;
			}
		});

		//@ts-ignore
		let options = citiesOptions[stateSlecte.label];

		return options;
	} catch (error) {
		return error;
	}
}
